export enum ReviewLinkType {
  GOOGLE = "google",
  FACEBOOK = "facebook",
  ZILLOW = "zillow",
  OTHER = "other",
}
